import { render, staticRenderFns } from "./PermissionRole.vue?vue&type=template&id=25b80a8c&"
import script from "./PermissionRole.vue?vue&type=script&lang=js&"
export * from "./PermissionRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports